
const PARENT_SELECTOR_NAME = '.pwc-studio-js-selectall';
const CHILD_SELECTOR_NAME = '.pwc-studio-js-selectall-item';
const DATA_ATTRIBUTE_NAME = 'data-selectall-reference-id';

function selectAllDirective(masterElement : HTMLInputElement, referenceId: string | null) {

    masterElement.addEventListener('click', function () {
        document.querySelectorAll(CHILD_SELECTOR_NAME).forEach(element => {
            if (element.getAttribute(DATA_ATTRIBUTE_NAME) === referenceId)
                (element as HTMLInputElement).checked = masterElement.checked;
        });
    });

    setTimeout(function () {
        const slaveElements = document.querySelectorAll(CHILD_SELECTOR_NAME);

        const setMasterState = function () {
            let checkedSlaves = Array.from(slaveElements).filter(elem => (elem as HTMLInputElement).checked);
            const isChecked = (checkedSlaves.length === slaveElements.length);
            const isIndeterminate = (checkedSlaves.length > 0 && checkedSlaves.length < slaveElements.length);
            masterElement.checked = isChecked;
            masterElement.indeterminate = isIndeterminate;
        };

        setMasterState();

        slaveElements.forEach(element => {
            element.addEventListener('click', setMasterState);
        });
    }, 0);
}

export function initializeSelectAll() {
    const masterCheckboxes = document.querySelectorAll(PARENT_SELECTOR_NAME);

    masterCheckboxes.forEach(masterCheckbox => {
        const referenceId = masterCheckbox.getAttribute(DATA_ATTRIBUTE_NAME);
        selectAllDirective(masterCheckbox as HTMLInputElement, referenceId);
    });
}
